import { useClearCondition } from '~/navigation'

export function ConditionsClear() {
  const reset = useClearCondition()
  return (
    <div className="mt-3 flex items-center justify-center">
      <button type="button" className="text-base text-accent-blue" onClick={reset}>
        人数・日時・絞り込み条件をクリア
      </button>
    </div>
  )
}
